__webpack_require__.p = "/bulk-delition-shared-candidates/referrals/";